import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/Header";

export default function PrivacyPage() {
  useEffect(() => { document.title = "Tavoli da Gioco — Privacy Policy"; }, []);

  return (
    <div className="min-h-screen bg-[#FDFBF7] dark:bg-[#181818]">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-[#2B593F] dark:text-[#8FC79F] hover:underline mb-6"
        >
          <ArrowLeft size={14} /> Torna al dashboard
        </Link>

        <h1 className="font-display text-3xl font-bold text-[#2D2A26] dark:text-[#F5F1EA] tracking-tight mb-2">Privacy Policy</h1>
        <p className="text-sm text-[#757169] dark:text-[#B8B2AA] dark:text-[#B8B2AA] mb-8">Ultimo aggiornamento: maggio 2025</p>

        <div className="bg-white dark:bg-[#111111] border border-[#EAE3D9] dark:border-[#2A2A2A] rounded-2xl p-6 sm:p-8 space-y-6 text-sm text-[#4A4742] dark:text-[#C8C2BA] leading-relaxed">

          <section>
            <h2 className="font-semibold text-[#2D2A26] dark:text-[#F5F1EA] text-base mb-2">1. Titolare del trattamento</h2>
            <p>
              Il titolare del trattamento dei dati personali è il team di <strong>Tavoli da Gioco</strong>,
              raggiungibile all'indirizzo <a href="mailto:info@tavolidagioco.eu" className="text-[#2B593F] hover:underline">info@tavolidagioco.eu</a>.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-[#2D2A26] dark:text-[#F5F1EA] text-base mb-2">2. Dati raccolti</h2>
            <p>Raccogliamo i seguenti dati personali forniti volontariamente dall'utente in fase di registrazione:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-[#757169] dark:text-[#B8B2AA]">
              <li>Nome e cognome (o nome visualizzato)</li>
              <li>Indirizzo email</li>
              <li>Nome utente (username)</li>
              <li>Password (conservata in forma cifrata, non recuperabile)</li>
            </ul>
            <p className="mt-2">
              Non raccogliamo dati sensibili, informazioni finanziarie né dati di terze parti.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-[#2D2A26] dark:text-[#F5F1EA] text-base mb-2">3. Finalità del trattamento</h2>
            <p>I dati sono utilizzati esclusivamente per:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-[#757169] dark:text-[#B8B2AA]">
              <li>Gestire l'accesso alla piattaforma (autenticazione)</li>
              <li>Mostrare il nome dell'utente agli altri partecipanti ai tavoli</li>
              <li>Inviare comunicazioni legate al servizio (es. reset password)</li>
            </ul>
          </section>

          <section>
            <h2 className="font-semibold text-[#2D2A26] dark:text-[#F5F1EA] text-base mb-2">4. Base giuridica</h2>
            <p>
              Il trattamento si basa sul consenso dell'utente, espresso al momento della registrazione,
              e sull'esecuzione del contratto di servizio (art. 6, par. 1, lett. a e b del GDPR).
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-[#2D2A26] dark:text-[#F5F1EA] text-base mb-2">5. Conservazione dei dati</h2>
            <p>
              I dati sono conservati per tutta la durata dell'account. L'utente può richiederne
              la cancellazione in qualsiasi momento scrivendo a{" "}
              <a href="mailto:info@tavolidagioco.eu" className="text-[#2B593F] hover:underline">info@tavolidagioco.eu</a>.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-[#2D2A26] dark:text-[#F5F1EA] text-base mb-2">6. Condivisione con terze parti</h2>
            <p>
              I dati personali non vengono venduti né ceduti a terze parti. Possono essere
              comunicati esclusivamente a fornitori tecnici strettamente necessari all'erogazione
              del servizio (es. hosting, database cloud), vincolati da accordi di riservatezza.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-[#2D2A26] dark:text-[#F5F1EA] text-base mb-2">7. Diritti dell'utente</h2>
            <p>In conformità al GDPR, ogni utente ha il diritto di:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-[#757169] dark:text-[#B8B2AA]">
              <li>Accedere ai propri dati</li>
              <li>Rettificarli o aggiornarli</li>
              <li>Richiederne la cancellazione ("diritto all'oblio")</li>
              <li>Opporsi al trattamento</li>
              <li>Presentare reclamo al Garante per la protezione dei dati personali</li>
            </ul>
            <p className="mt-2">
              Per esercitare questi diritti scrivere a{" "}
              <a href="mailto:info@tavolidagioco.eu" className="text-[#2B593F] hover:underline">info@tavolidagioco.eu</a>.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-[#2D2A26] dark:text-[#F5F1EA] text-base mb-2">8. Modifiche alla policy</h2>
            <p>
              Ci riserviamo di aggiornare questa policy. In caso di modifiche sostanziali
              gli utenti saranno informati tramite avviso in app o email.
            </p>
          </section>

        </div>
      </main>
    </div>
  );
}
